module.exports = __webpack_public_path__ + "img/568.08d412ec.jpg";